module.exports = __webpack_public_path__ + "static/media/hot66.1bef2849.jpg";